<template>
    <div class="subscription success">Synaxy vous remercie pour votre abonnement.</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
